import { ExternalOrderInfo } from "@api/throughShipment/externalOrderApi";
import { PickupTypeByValue, convertCurrencyType } from "@constant/ThroughShipment";

import React from "react";

import { Row, Title, RowContent, NormalTitle, Divide } from "./style";

type Props = {
  externalOrderInfo: ExternalOrderInfo;
  showWarehouse?: boolean;
};

const ContractDetail = ({ externalOrderInfo, showWarehouse = false }: Props) => {
  return (
    <>
      <Row>
        <Title>合作通路類型</Title>
        <RowContent width={1000}>
          <Title>{externalOrderInfo.retailerRegionType}</Title>
        </RowContent>
      </Row>
      <Row marginTop="20px">
        <NormalTitle>地區</NormalTitle>
        <RowContent width={1000}>
          <NormalTitle>{externalOrderInfo.retailerRegion}</NormalTitle>
        </RowContent>
      </Row>
      {showWarehouse && (
        <Row marginTop="20px">
          <NormalTitle>出庫倉庫</NormalTitle>
          <RowContent width={1000}>
            <NormalTitle>{externalOrderInfo.warehouseName ?? "-"}</NormalTitle>
          </RowContent>
        </Row>
      )}
      <Row marginTop="20px">
        <NormalTitle>通路名稱</NormalTitle>
        <RowContent width={1000}>
          <NormalTitle>{externalOrderInfo.retailerName}</NormalTitle>
        </RowContent>
      </Row>
      <Row marginTop="20px">
        <NormalTitle>通路電話</NormalTitle>
        <RowContent width={1000}>
          <NormalTitle>{externalOrderInfo.retailerContactPhone}</NormalTitle>
        </RowContent>
      </Row>
      <Row marginTop="20px">
        <NormalTitle>通路窗口</NormalTitle>
        <RowContent width={1000}>
          <NormalTitle>{externalOrderInfo.retailerContactName}</NormalTitle>
        </RowContent>
      </Row>
      <Row marginTop="20px">
        <NormalTitle>通路電子郵件</NormalTitle>
        <RowContent width={1000}>
          <NormalTitle>{externalOrderInfo.retailerContactEmail}</NormalTitle>
        </RowContent>
      </Row>
      <Row marginTop="20px">
        <NormalTitle>通路出貨倉點</NormalTitle>
        <RowContent width={1000}>
          <NormalTitle>{`${externalOrderInfo!.retailerWarehouseName}(${
            PickupTypeByValue[externalOrderInfo!.pickupType]
          })`}</NormalTitle>
        </RowContent>
      </Row>
      <Divide />
      <Title>合作條件</Title>
      <Row marginTop="20px" marginBottom="26px">
        <NormalTitle>合作模式</NormalTitle>
        <RowContent width={1000}>
          <NormalTitle>{externalOrderInfo.retailerContractType.toString()}</NormalTitle>
        </RowContent>
      </Row>
      <Title>付款條件</Title>
      <Row marginTop="20px">
        <NormalTitle>經銷商付款時間</NormalTitle>
        <RowContent width={100}>
          <NormalTitle>出貨後</NormalTitle>
        </RowContent>
        <RowContent width={400}>
          <NormalTitle>{externalOrderInfo.retailerDaysAfterMonthlyStatement}</NormalTitle>
        </RowContent>
        <RowContent width={1000}>
          <NormalTitle>日</NormalTitle>
        </RowContent>
      </Row>
      <Row marginTop="20px">
        <NormalTitle>經銷商付款時間</NormalTitle>
        <RowContent width={100}>
          <NormalTitle>出貨後</NormalTitle>
        </RowContent>
        <RowContent width={400}>
          <NormalTitle>{externalOrderInfo!.retailerDaysAfterMonthlyStatement + 30}</NormalTitle>
        </RowContent>
        <RowContent width={1000}>
          <NormalTitle>日付款給供應商</NormalTitle>
        </RowContent>
      </Row>
      <Row marginTop="20px">
        <NormalTitle>經銷商支付幣別</NormalTitle>
        <RowContent width={1000}>
          <NormalTitle>{convertCurrencyType(externalOrderInfo.currency)}</NormalTitle>
        </RowContent>
      </Row>
      <Row marginTop="20px">
        <NormalTitle>匯率</NormalTitle>
        <RowContent width={1000}>
          <NormalTitle>{externalOrderInfo.currencyRate}</NormalTitle>
        </RowContent>
      </Row>
    </>
  );
};

export default ContractDetail;
